module.exports = __webpack_public_path__ + "img/contact_part2img.1bd466df.jpg";